import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {useQueryClient} from '@tanstack/react-query';
import {changeLanguage} from '../../translations';

// styles
import {IconLanguage, StyledButton} from './LanguageSelector-styles';
import {TextColors, TextDefault} from '../../styles';

// types
type Props = {
  disabled: boolean;
};

/**
 * Language selector
 */
const LanguageSelector = ({disabled}: Props) => {
  const {t, i18n} = useTranslation();
  const queryClient = useQueryClient();

  const toggleLanguage = async () => {
    await changeLanguage(i18n.language === 'en' ? 'fr' : 'en', queryClient);
  };

  return (
    <StyledButton
      onClick={toggleLanguage}
      disabled={disabled}
      variant="outlined"
      fullWidth={false}
      startDecorator={<IconLanguage />}>
      <TextDefault
        bold="bold"
        color={disabled ? TextColors.disabled : TextColors.brand}>
        {t('opposite_language')}
      </TextDefault>
    </StyledButton>
  );
};

export {LanguageSelector};
